module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-tag', [_vm._v("Tag label")]), _vm._v(" "), _c('b-tag', {
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("Rounded tag label")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90165f58"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/tag/examples/ExSimple.vue
// module id = 1243
// module chunks = 16 181